module.exports = __webpack_public_path__ + "media/images/emblems/Lamone-coat_of_arms-97552da118994c94c548765c64303661.svg";